export const PridobiNovice = {
  methods: {
    GetSeznamNovic () {
      let param = []
      this.clientAgent.postNovice(
        this,
        '',
        param,
        null,
        'SetSeznamNovice',
        'ErrSeznamNovice'
      )
    },
    SetSeznamNovice (podatki) {
      let novicePogostaVprasanja = []
      let t2Magazin = []
      for (let i = 0; i < podatki.articles.length; i++) {
        if (podatki.articles[i].article.category === 'Naslovna stran') {
          t2Magazin.push(podatki.articles[i])
        } else {
          novicePogostaVprasanja.push(podatki.articles[i])
        }
      }
      return this.SeznamNovic(novicePogostaVprasanja, t2Magazin)
    },
    ErrSeznamNovice (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/PridobivanjeNovic/PridobiNovice.js